<template>
  <div id="app" class="bg-custom-bg min-h-screen
    px-[16px] lg:px-[100px] lg:pt-[44px] pt-[16px] lg:pb-[44px]">
    <!-- Navbar -->
    <header class="header">
      <img src="./assets/logo.svg" alt="logo" class="w-auto h-[32px] lg:h-[36px]">
      <span class="header-text hidden lg:block">Eliminate jargon, Trade top memes</span>
      <a href="https://t.me/BigBagsCommunity" target="_blank" class="btn community-button px-[14px] py-[9px]">
        <img src="./assets/icons/telegram.svg" alt="telegram" class="w-auto h-[24px]">
        <span>Join Community</span>
      </a>
    </header>

    <div class="header-text block lg:hidden flex justify-center mt-[54px]">
      <span>Eliminate jargon, Trade top memes</span>
    </div>

    <div class="mx-auto w-full lg:w-[786px] pt-[24px]">
      <img src="./assets/banner.png" alt="banner" class="w-full h-auto">
    </div>

    <!-- Filter Section -->
    <div class="flex flex-col sm:flex-row justify-center mt-6 space-y-4 sm:space-y-0 sm:space-x-4">
      <a href="#" class="filter px-[14px] py-[8px] rounded-full"
        :class="currentCategory === 'solana-meme-coins' ? 'filterActive' : 'filterInactive'"
        @click="fetchTokens('solana-meme-coins')">
        <img src="./assets/icons/solana.png" alt="Network Icon" class="w-auto h-[20px]">
        <span>Solana</span>
      </a>
      <a href="#" class="filter px-[14px] py-[8px] rounded-full"
        :class="currentCategory === 'pump-fun' ? 'filterActive' : 'filterInactive'"
        @click="fetchTokens('pump-fun')">
        <img src="./assets/icons/pump.png" alt="Network Icon" class="w-auto h-[20px]">
        <span>Pump Fun</span>
      </a>
      <a href="#" class="filter px-[14px] py-[8px] rounded-full"
        :class="currentCategory === 'base-meme-coins' ? 'filterActive' : 'filterInactive'"
        @click="fetchTokens('base-meme-coins')">
        <img src="./assets/icons/base.png" alt="Network Icon" class="w-auto h-[20px]">
        <span>Base</span>
      </a>
      <!-- <a href="#" class="filter px-[14px] py-[8px] rounded-full"
        :class="currentCategory === 'binance-smart-chain' ? 'filterActive' : 'filterInactive'"
        @click="fetchTokens('binance-smart-chain')">
        <img src="./assets/icons/solana.png" alt="Network Icon" class="w-auto h-[20px]">
        <span>BNB</span>
      </a>
      <a href="#" class="filter px-[14px] py-[8px] rounded-full"
        :class="currentCategory === 'meme-token' ? 'filterActive' : 'filterInactive'"
        @click="fetchTokens('meme-token')">
        <img src="./assets/icons/solana.png" alt="Network Icon" class="w-auto h-[20px]">
        <span>Meme</span>
      </a> -->
    </div>

    <!-- Pool Table -->
    <div class="overflow-x-auto">
      <div v-if="loading" class="flex justify-center items-center">
        <img src="./assets/icons/loadingSpinner.svg" alt="loading"
          class="w-auto h-[44px] mt-[100px]">
      </div>
      <table v-else class="min-w-full text-center text-white"
        style="border-spacing: 0 10px;">
        <thead>
          <tr>
            <th class="table-head nohover text-left">TOKEN</th>
            <th class="table-head nohover">PRICE</th>
            <th class="table-head" :class="currentSort === '24h' ? 'table-headActive' : ''">
              <a href="#" @click="sortBy24h">
                24H
              </a>
            </th>
            <th class="table-head" :class="currentSort === '7d' ? 'table-headActive' : ''">
              <a href="#" @click="sortBy7d">
                7D
              </a>
            </th>
            <th class="table-head" :class="currentSort === 'mcap24h' ? 'table-headActive' : ''">
              <a href="#" @click="sortByMcap24h">
                MCAP 24H
              </a>
            </th>
            <th class="table-head" :class="currentSort === 'totalmcap' ? 'table-headActive' : ''">
              <a href="#" @click="sortByTotalMcap">
                TOTAL MCAP</a>
            </th>
            <th class="table-head" :class="currentSort === 'totalvolume' ? 'table-headActive' : ''">
              <a href="#" @click="sortByTotalVolume">
                TOTAL VOL
              </a>
            </th>
            <th class="table-head nohover">ATH</th>
            <th class="table-head nohover"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="token in tokens" :key="token.id">
          <td class="py-[12px] px-[12px] flex items-center min-w-[160px]"
            style="position: sticky; left: 0;">
            <img :src="token.image" alt="Token Icon" class="w-[44px] h-[44px] mr-2 rounded-full">
            <div class="flex flex-col items-start text-left">
              <span class="text-white" style="text-transform: uppercase;">{{ token.symbol }}</span>
              <span class="text-white text-sm opacity-50">{{token.name}}
              </span>
            </div>
          </td>
          <td class="py-3 px-5">${{ token.current_price }}</td>
          <td class="py-3 px-5" :class="token.price_change_percentage_24h_in_currency > 0 ?
            'text-green-500' : 'text-red-500'">
            {{ token.price_change_percentage_24h_in_currency ?
            token.price_change_percentage_24h_in_currency.toFixed(2) + '%' : 'N/A' }}
          </td>
          <td class="py-3 px-5" :class="token.price_change_percentage_7d_in_currency > 0 ?
            'text-green-500' : 'text-red-500'">
            {{ token.price_change_percentage_7d_in_currency ?
            token.price_change_percentage_7d_in_currency.toFixed(2) + '%' : 'N/A' }}
          </td>
          <td
            class="py-3 px-5"
          >
            <span class="flex items-center" style="align-items: center; justify-content: center;">
              {{ formatMarketCapChange(token.market_cap_change_24h) }}
              <img
                v-if="token.market_cap_change_24h >= 0"
                src="./assets/icons/up-arrow.svg"
                alt=""
                class="w-[12px] h-[12px] ml-1"
              />
              <img
                v-else
                src="./assets/icons/down-arrow.svg"
                alt=""
                class="w-[12px] h-[12px] ml-1"
              />
            </span>
          </td>
          <td class="py-3 px-5">{{ shortData(token.market_cap) }}</td>
          <td class="py-3 px-5">{{ shortData(token.total_volume) }}</td>
          <td class="py-3 px-5">${{ token.ath }}</td>
          <td class="py-[12px] px-[12px]">
            <a href="#" class="btn button-trade px-[14px] py-[9px]"
              @click="fetchTokenAddress(token.id, currentCategory)">
              <span v-if="!loadingStates[token.id]">Trade Now</span>
              <img v-else src="./assets/icons/loadingSpinner.svg" alt="loading"
                class="w-auto h-[24px]">
            </a>
          </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <footer
      class="footer w-full bottom-0 left-0
            sm:relative lg:fixed
            lg:h-[44px] sm:h-auto md:h-[44px]
            flex flex-col sm:flex-row items-center justify-between
            px-[16px] lg:px-[100px] md:px-[16px]
            py-[16px] lg:py-0 md:py-[16px]">
      <span class="opacity-50">© BigBags 2025</span>
      <div class="flex items-center gap-[12px]">
        <span class="opacity-50">Follow us</span>
        <a href="https://t.me/bigbagsapp" target="_blank" class="flex items-center gap-[8px]">
          <img src="./assets/icons/telegram.svg" alt="Telegram" class="w-auto h-[20px]" />
          <span>Telegram</span>
        </a>
        <a href="https://x.com/bigbagsapp" target="_blank" class="flex items-center gap-[8px]">
          <img src="./assets/icons/x.svg" alt="Xtwitter" class="w-auto h-[20px]" />
          <span>X/Twitter</span>
        </a>
    </div>
  </footer>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import shortNum from 'number-abbreviate';
// import coingeckoService from '@/services/api';
export default {
  data() {
    return {
      loadingStates: {},
      currentSort: '',
    };
  },
  computed: {
    ...mapState(['tokens', 'loading', 'currentCategory']),
  },
  created() {
    this.fetchTokens('solana-meme-coins');
  },
  methods: {
    ...mapActions(['fetchTokens']),

    async fetchTokens(list) {
      this.$store.dispatch('fetchTokens', list);
    },

    shortData(data) {
      return shortNum(data, 2);
    },

    async fetchTokenAddress(id, category) {
      this.loadingStates[id] = true;
      try {
        await this.$store.dispatch('fetchTokenAddress', { id, category });
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingStates[id] = false;
      }
    },

    sortBy24h() {
      this.tokens.sort((a, b) => {
        this.currentSort = '24h';
        const aValue = a.price_change_percentage_24h_in_currency ?? -Infinity;
        const bValue = b.price_change_percentage_24h_in_currency ?? -Infinity;
        return bValue - aValue;
      });
    },

    sortBy7d() {
      this.tokens.sort((a, b) => {
        this.currentSort = '7d';
        const aValue = a.price_change_percentage_7d_in_currency ?? -Infinity;
        const bValue = b.price_change_percentage_7d_in_currency ?? -Infinity;
        return bValue - aValue;
      });
    },

    sortByMcap24h() {
      this.tokens.sort((a, b) => {
        this.currentSort = 'mcap24h';
        const aValue = a.market_cap_change_24h ?? -Infinity;
        const bValue = b.market_cap_change_24h ?? -Infinity;
        return bValue - aValue;
      });
    },

    sortByTotalMcap() {
      this.tokens.sort((a, b) => {
        this.currentSort = 'totalmcap';
        const aValue = a.market_cap ?? -Infinity;
        const bValue = b.market_cap ?? -Infinity;
        return bValue - aValue;
      });
    },

    sortByTotalVolume() {
      this.tokens.sort((a, b) => {
        this.currentSort = 'totalvolume';
        const aValue = a.total_volume ?? -Infinity;
        const bValue = b.total_volume ?? -Infinity;
        return bValue - aValue;
      });
    },

    formatMarketCapChange(value) {
      const sign = value >= 0 ? '+' : '-';
      const formattedValue = this.shortData(Math.abs(value));
      return `${sign}${formattedValue}`;
    },
  },
};
</script>

<style scoped>
/* You can add any custom styles here */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 24px;
  padding-right: 10px;
  background-color: #133B3A30;
  border: 1px solid #FFFFFF10;
  border-radius: 9999px;
  backdrop-filter: blur(24px);
  position: sticky;
  top: 44px;
  z-index: 10;
}

.header-text {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  background: radial-gradient(50% 50% at 50% 50%, #F6FFF7 0%, #CEFFD5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.community-button {
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  background-color: #2AB229;
  border: 1px solid #FFFFFF10;
}

.community-button:hover {
  background-color: #158814;
}

.filter {
  color: #FFFFFF;
  border-radius: 9999px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 400;
}

.filterActive {
  color: #FFFFFF;
  border: 1px solid #2AB229;
}

.filterInactive {
  color: #FFFFFF80;
  border: 1px solid #FFFFFF20;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

td {
  background: linear-gradient(180deg, #1F3234 0%, #0E1E21 100%);
}

td:first-child
{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
td:last-child
{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

.table-head {
  color: #F6FFF760;
  padding: 12px 12px;
  font-size: 16px;
  font-weight: 500;
}

.table-headActive {
  color: #FFFFFF;
}

.table-head:not(.nohover) :hover {
  color: #FFFFFF;
}

.rawborder {
  border: 1px solid #FFFFFF20;
}

.button-trade {
  color: #FFFFFF;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid #2AB229;
}

.button-trade:hover {
  background-color: #2AB229;
}

.footer {
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 400;
  background-color: #0F1F22;
}
</style>
